import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &.has-image{
    justify-content: flex-start;
  }
`

interface Props {
  holidayType: string;
  hasImage: boolean;
}

export function ResultsFilteredByHolidayType({ holidayType, hasImage }: Props) {
  return (
    <Container className={cn({ 'has-image': hasImage })}>
      <Heading as="span" colour="neutral-eight" variant="heading1">
        <i>{holidayType}</i>&nbsp;
        travel inspiration
      </Heading>
    </Container>
  )
}
